import ManagerDiscoveryCategories from './ManagerDiscoveryCategories.container';

export default ManagerDiscoveryCategories;
